import SmartLabel from 'components/v2/labels/SmartLabel';
import { Calendar } from 'primereact/calendar';
import styled from 'styled-components';

import CalendarIcon from './CalendarIcon';
import { ComponentProps } from 'react';

const DatePicker: React.FunctionComponent<{
  label: string;
  tooltip?: string;
  initialDate: any | undefined;
  required?: boolean;
  disabled?: boolean;
  tooltipPosition?: any;
  labelStyle?: any;
  onChange?: ComponentProps<typeof Calendar>['onChange'];
  error?: any;
  dateFormat?: string;
  maxDate?: Date;
  minDate?: Date;
  placeholder?: string;
}> = ({
  label,
  labelStyle,
  required,
  tooltip,
  tooltipPosition,
  initialDate,
  error,
  disabled,
  onChange,
  dateFormat,
  maxDate,
  minDate,
  placeholder = 'Select',
}) => {
  return (
    <div>
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          tooltipPosition={tooltipPosition}
          hasValue={initialDate}
          error={error}
        />
      )}
      <CalendarStyles>
        <Calendar
          style={{ height: '44px' }}
          dateFormat={dateFormat ?? 'dd-mm-yy'}
          value={initialDate}
          disabled={disabled}
          placeholder={disabled ? undefined : placeholder}
          onChange={onChange}
          icon={CalendarIcon}
          showIcon={!disabled}
          maxDate={maxDate}
          minDate={minDate}
        />
      </CalendarStyles>
    </div>
  );
};

const CalendarStyles = styled.div`
  input {
    padding: 1rem;
    font-size: 14px;
  }
  .p-calendar.p-calendar-disabled .p-inputtext {
    background-color: ${(props) => props.theme.colors.elementsFilledInput};
    color: ${(props) => props.theme.colors.primaryBlack70};
    border: none;
  }
  .p-calendar.p-calendar-disabled.p-inputwrapper {
    border: none;
  }

  .p-button {
    background-color: transparent;
    color: ${(props) => props.theme.colors.primaryBlack};
    border: none;
  }

  .p-button:hover {
    background-color: transparent;
    color: ${(props) => props.theme.colors.primaryBlack};
  }

  .p-inputtext {
    border-radius: 2px;
    border: none;
  }

  .p-inputtext:enabled:focus {
    box-shadow: none;
    outline: none;
  }

  .p-inputwrapper {
    width: 100%;
    border: 1px solid ${(props) => props.theme.colors.elementsInputBorder};
    border-radius: 2px;
    outline: none;
    &:hover {
      border-color: ${(props) => props.theme.colors.primaryOrange};
    }
  }
`;

export default DatePicker;
